import { useEffect } from 'react';

import type { CarouselRef, HandlerRef } from '..';
import { SwipeDirection } from '../constants';
import { getSlideMeta } from '../utils/scroll';

export const useActiveIndex = (
  carouselRef: CarouselRef,
  handlerRef: HandlerRef,
  activeIndex: number
) => {
  useEffect(() => {
    if (activeIndex !== null && handlerRef.current) {
      handlerRef.current.scrollToIndex(activeIndex);
    }
  }, [activeIndex, handlerRef]);

  const getScrollSlideIndex = (index: number, dir: SwipeDirection) => {
    if (!carouselRef.current) return index;
    const { fullyVisibleSlides, totalSlides } = getSlideMeta(carouselRef);
    if (totalSlides <= fullyVisibleSlides) return index;
    const maxScrollIndex = totalSlides - fullyVisibleSlides;
    if (dir === SwipeDirection.Next) {
      return Math.min(index + fullyVisibleSlides, maxScrollIndex);
    }

    return Math.max(index - fullyVisibleSlides, 0);
  };

  return {
    getPrevIndex: (i: number) => getScrollSlideIndex(i, SwipeDirection.Prev),
    getNextIndex: (i: number) => getScrollSlideIndex(i, SwipeDirection.Next),
  };
};
